import React from 'react';
import { connect } from 'react-redux';

import SaveIcon from '@material-ui/icons/Save';
import TextField from 'material-ui/TextField';

import HDrawer from '../../common/HDrawer';
import * as CalendarState from '../../../state/reducer/calendar/calendar';
import Console from '../../../lib/debug';

export class SaveSessionToLibraryClass extends React.Component {
    state = { title: '' };

    componentWillReceiveProps(nextProps) {
        if (!nextProps.session) return;
        this.setState({
            title: nextProps.session.title
        });
    }

    handleClose = () => {
        CalendarState.toggleSaveSessionToLibrary(false);
    };

    handleSave = () => {
        let session = this.props.session;
        session.title = this.state.title;
        CalendarState.saveSessionToLibrary(session);
    };

    handleChange = e => {
        this.setState({
            title: e.target.value
        });
    };

    render() {
        Console.render('SaveSessionToLibrary');
        return (
            <HDrawer
                open={this.props.open}
                onClose={this.handleClose}
                onSave={this.handleSave}
                title="Save Session To Library"
                icon={<SaveIcon />}
                subTitle={this.state.title}
                description=""
                actions={true}
            >
                <TextField
                    id="title"
                    label="Title"
                    type="search"
                    value={this.state.title}
                    fullWidth
                    margin="normal"
                    onChange={this.handleChange}
                />
            </HDrawer>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        open: state.calendar.uiTree.saveSessionToLibraryDialog,
        session: state.calendar.uiTree.session,
        ...ownProps
    };
};

export default connect(mapStateToProps)(SaveSessionToLibraryClass);
